<div class="payment-component" #adyen></div>
